<template>
  <div id="tdMainDiv">
    <div id="tdContentDiv">
      <div id="tdFilterDiv">
        <el-button
          v-if="bizType === 'Quality'"
          plain
          type="primary"
          size="small"
          icon="el-icon-circle-check"
          @click="handleBatchReview"
          >批量审核</el-button
        >
        <span class="tdnFilterTitle" style="width: 30px"> 标题: </span>
        <el-input
          placeholder="请输入标题搜索"
          v-model="filterName"
          class="input-with-select"
          size="small"
          style="width: 200px"
          clearable
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="inputSearch"
          ></el-button>
        </el-input>
        <span v-if="!isZt" class="tdnFilterTitle"> 工程划分: </span>
        <treeselect
          v-if="!isZt"
          v-model="partCode"
          :load-options="loadOptions"
          :options="options"
          style="width: 250px"
          placeholder="请选择工程划分"
          :normalizer="normalizer"
          class="tree-select"
          :searchable="false"
        />
        <span class="tdnFilterTitle"> 申请时间: </span>
        <el-date-picker
          v-model="dateValues"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy年MM月dd日"
          value-format="yyyy-MM-dd"
          style="width: 280px"
          size="small"
        >
        </el-date-picker>
        <span class="tdnFilterTitle" style="width: 30px"> 状态: </span>
        <el-select
          v-model="statusType"
          placeholder="请选择流程状态"
          size="small"
          style="width: 90px"
        >
          <el-option
            v-for="item in statusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <span v-if="!isZt" class="tdnFilterTitle" style="width: 60px">
          业务类型:
        </span>
        <el-select
          v-if="!isZt"
          v-model="bizType"
          placeholder="请选择业务类型"
          size="small"
          style="width: 100px"
        >
          <el-option
            v-for="item in bizTypeArr"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <!-- <el-button @click="test()">调用test</el-button> -->
      </div>
      <div id="tdTableDiv">
        <el-table
          :data="tableData"
          border
          stripe
          size="small"
          :header-cell-style="{ background: '#ECF5FF', color: '#606266' }"
          @selection-change="handleSelectionChange"
          style="width: 100%"
          height="100%"
        >
          <el-table-column
            v-if="bizType === 'Quality'"
            :selectable="selectable"
            align="center"
            type="selection"
          >
          </el-table-column>
          <el-table-column
            prop="title"
            align="left"
            header-align="center"
            :show-overflow-tooltip="true"
            min-width="150"
            label="标题"
          ></el-table-column>
          <el-table-column
            prop="variables.own_section_name"
            align="left"
            header-align="center"
            :show-overflow-tooltip="true"
            width="150"
            label="公司"
          ></el-table-column>
          <el-table-column
            v-if="!isZt"
            prop="instProps.unitName"
            align="left"
            header-align="center"
            :show-overflow-tooltip="true"
            width="150"
            label="单位工程"
          ></el-table-column>
          <el-table-column
            v-if="!isZt"
            prop="instProps.optionName"
            align="left"
            header-align="center"
            :show-overflow-tooltip="true"
            width="150"
            label="分项工程"
          ></el-table-column>
          <el-table-column
            v-if="!isZt"
            prop="instProps.subOptionName"
            align="left"
            header-align="center"
            :show-overflow-tooltip="true"
            width="150"
            label="子分项工程"
          ></el-table-column>
          <el-table-column
            prop="drafterName"
            align="left"
            header-align="center"
            :show-overflow-tooltip="true"
            width="100"
            label="申请人"
          ></el-table-column>
          <el-table-column
            prop="drafterOrgName"
            align="left"
            header-align="center"
            :show-overflow-tooltip="true"
            width="120"
            label="部门"
          ></el-table-column>
          <el-table-column
            prop="flowStatusName"
            align="center"
            :show-overflow-tooltip="true"
            width="80"
            label="状态"
          >
            <template slot-scope="scope">
              {{
                scope.row.flowStatusName === "草稿"
                  ? "未提交"
                  : scope.row.flowStatusName
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="submitTime"
            align="center"
            width="125"
            label="申请日期"
          ></el-table-column>
          <el-table-column fixed="right" label="操作" align="center" width="95">
            <template slot-scope="scope">
              <el-tooltip content="操作" placement="top">
                <el-button
                  size="mini"
                  type="primary"
                  icon="el-icon-edit"
                  @click="handleData(scope.row)"
                  circle
                  plain
                ></el-button>
              </el-tooltip>
              <el-tooltip
                v-if="scope.row.bizType.startsWith('Quality')"
                class="item"
                effect="dark"
                content="相关资料"
                placement="top"
              >
                <el-button
                  @click="handleRelatedClick(scope.row)"
                  size="mini"
                  type="primary"
                  icon="el-icon-tickets"
                  circle
                  plain
                ></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div id="tdPaginationDiv">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[15, 30, 50, 100]"
          :page-size="rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <div class="enptyDiaDiv">
      <el-dialog
        closed="true"
        closable="false"
        :visible.sync="enptyDialogVisible"
        @close="updateData"
        width="0"
        height="0"
      ></el-dialog>
    </div>
    <div class="tdDialogDiv">
      <el-dialog
        title="相关质料"
        :show-close="true"
        top="1vh"
        width="90%"
        :close-on-click-modal="false"
        :visible="relatedDialogVisible"
        :before-close="() => (relatedDialogVisible = false)"
      >
        <new-related-construction-view
          ref="newRelatedConstructionView"
          :projectId="prjId"
          :sectionId="sectionId"
          :directory-id="directoryId"
          :prj-code="sendProjectCode"
          :section-code="sendSectionCode"
          :quality-inst-id="qualityInstId"
        />
      </el-dialog>
      <el-dialog
        title="批量审批意见"
        :show-close="false"
        :close-on-click-modal="false"
        :visible.sync="batchReviewDialogVisible"
      >
        <el-form
          v-loading="batchReviewing"
          element-loading-text="批量审核中,请勿关闭或刷新页面!"
        >
          <el-form-item label="办理意见" label-width="80px" required>
            <el-input
              type="textarea"
              v-model="batchReviewComment"
              :rows="6"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button
            :loading="batchReviewing"
            type="primary"
            size="medium"
            @click="handleBatchReviewSure"
            >确 定</el-button
          >
          <el-button
            :loading="batchReviewing"
            @click="batchReviewDialogVisible = false"
            size="medium"
            style="margin-left: 6px"
            >取 消</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { fixed_parent_id } from "@/utils";
import {
  bjcaGenSign,
  getFlowToolbar,
  getProcessActiveTask,
  queryUserTask,
  workflowPass
} from "../api/workflow";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import NewRelatedConstructionView from "../components/todo/NewRelatedConstructionView";
import { getChildren } from "../api/prjPart";
import { getCategoryList } from "../api/category";
import { processSign } from "../api/bjca/bjca";
export default {
  name: "Todo",
  components: {
    NewRelatedConstructionView,
    Treeselect
  },
  data() {
    return {
      isZt: false, //判断是否是项目
      rows: 15,
      total: 0,
      currentPage: 1,
      tableData: [],
      keyword: "",
      dateValues: [],
      statusType: "",
      filterName: "",
      caFlag: false,
      pdfFlag: false,
      batchReviewCount: 0,
      batchReviewing: false,
      batchReviewComment: "",
      enptyDialogVisible: false,
      relatedDialogVisible: false,
      batchReviewDialogVisible: false,
      partCode: undefined,
      mainPartCode: "",
      options: [],
      bizType: "all",
      bizTypeArr: [
        {
          id: "all",
          name: "全部"
        },
        {
          id: "Quality",
          name: "质检资料"
        }
      ],
      multipleSelection: [],
      errorBatchReviewData: [],
      normalizer(node) {
        return {
          id: node.id,
          label: node.text
        };
      },
      statusOptions: [
        {
          value: "",
          label: "全部"
        },
        {
          value: "2",
          label: "退回"
        },
        {
          value: "3",
          label: "流转中"
        }
      ],
      prjId: "",
      sectionId: "",
      directoryId: "",
      qualityInstId: "",
      sendProjectCode: "",
      sendSectionCode: ""
    };
  },
  methods: {
    test() {
      console.log("test", window.parent);
      //   window.parent.chooseItem({ url: "/todo" })
      window.parent.iframePushToMethd({
        fullPath: "605970535309946880->606026177744973824->606026263788912640",
        fullPathName: "综合管理->行政办公->公文管理",
        id: "607476646674968576",
        resourceId: "606026263788912640",
        resourceName: "公文管理"
      });
    },
    handleRelatedClick(row) {
      this.prjId = row.variables.own_project_id;
      this.sectionId = row.variables.own_section_id;
      this.sendProjectCode = row.variables.own_project_code;
      this.sendSectionCode = row.variables.own_section_code;
      this.directoryId = row.instProps.directoryId;
      this.qualityInstId = row.bizPk;

      if (row.instProps.partCode) {
        this.relatedDialogVisible = true;
        this.$nextTick(() => {
          this.$refs.newRelatedConstructionView.update(row.instProps.partCode);
        });
      } else {
        this.$message.warning("分部分项编码不存在!");
      }
    },
    inputSearch() {
      this.keyword = this.filterName;
      this.handleCurrentChange(1);
    },
    handleSizeChange(val) {
      this.rows = val;
      this.currentPage = 1;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTableData();
    },
    updateData() {
      this.getTableData();
    },
    getTableData() {
      this.tableData = [];
      var submitFromTime = "";
      var submitToTime = "";

      if (this.dateValues && this.dateValues.length === 2) {
        submitFromTime = this.dateValues[0];
        submitToTime = this.dateValues[1];
      }

      //因为计量的待办不需要这个参数，暂时注释
      var list = [];
      if (!!this.partCode) {
        var jp = {
          propName: "partCode",
          propValuePreLike: this.partCode
        };
        list.push(jp);
      }

      const user = JSON.parse(localStorage.getItem("Admin-Data"));
      let status = this.statusType;
      if (this.statusType == "") {
        status = "2,3,4";
      }
      var params = {
        page: this.currentPage,
        rows: this.rows,
        userId: user.userId,
        jsonInstProps: JSON.stringify(list),
        bizTitle: this.keyword,
        status: status,
        submitFromTime: submitFromTime,
        submitToTime: submitToTime,
        resourceId:fixed_parent_id
      };

      if (this.bizType !== "all") {
        params.bizKeyPreLike = this.bizType;
      }

      this.$axios
        .post(
          `/api/workflow/personalWork/getTodoList?resourceId=${fixed_parent_id}`,
          this.$qs.stringify(params)
        )

        .then(response => {
          //   this.total = response.data.total;
          if (response.data.rows != null && response.data.rows.length > 0) {
            this.tableData = [];
            //过滤掉无效业务地址的数据
            // response.data.rows.filter((it) => {
            //   if (!it.bizType.startsWith("Quality")) {
            //     if (it.doUrl != undefined && it.doUrl != null) {
            //       this.tableData.push(it);
            //     }
            //   } else {
            //     this.tableData.push(it);
            //   }
            // });
            this.tableData = response.data.rows;
          } else {
            this.tableData = [];
          }
          this.total = response.data.total;
        })
        .catch(error => {
          console.log("error:" + error.toString());
        });
    },
    loadOptions({ action, parentNode, callback }) {
      if (action === "LOAD_CHILDREN_OPTIONS") {
        getChildren(parentNode.id)
          .then(res => {
            res.forEach(item => {
              item.children = null;
            });
            parentNode.children = res;
            callback();
          })
          .catch(error => {
            this.$message.error(error);
            callback();
          });
        // this.loadTree(parentNode.id).then(res => {
        //   if (res.data.length > 0) {
        //     if (res.data.length > 0) {
        //       res.data.forEach(ele => {
        //         if (ele.state === 'closed') {
        //           ele.children = null
        //         } else {
        //           ele.children = undefined
        //         }
        //       });
        //     }
        //     parentNode.children = res.data
        //   }
        //   callback()
        // })
      }
    },
    selectable(row) {
      if (row.taskKey === "usertask1") {
        return 0;
      }
      return 1;
    },
    async handleData(data) {
      if (data.bizType.startsWith("Quality")) {
        let flowStatus = data.flowStatus;
        if (2 == flowStatus) {
          //判断
          //退回 判断是否在申报节点
          const result = await getProcessActiveTask(
            data.bizPk
          ).catch(msg => []);
          if (result.data && result.data.length > 0) {
            const item = result.data[0];
            if (item.id == "usertask1") {
              flowStatus = 1;
            }
          }
        }
        if (flowStatus === 1) {
          let clientPath = "http://localhost:8686/MessageService/";
          let projectInfo = JSON.parse(sessionStorage.getItem("projectInfo"));
          //未打开客户端
          const user = JSON.parse(localStorage.getItem("Admin-Data"));
          const data1 = JSON.stringify({
            token: localStorage.getItem("Admin-Msg"),
            FileId: data.bizPk,
            UserId: user.userId,
            CurrentApprovalStatus: 1,
            ProjectId: projectInfo.projectId,
            Authority: `${window.location.hostname}:${window.location.port}`
          });
          this.enptyDialogVisible = true;
          this.$message.success("正在启动客户端，请稍候...");
          this.$axios.get(`${clientPath}${data1}`).then(res => {
            if (res.data === "true") {
              this.$message.success("正在启动客户端，请稍候...");
            } else {
              this.$message.error("启动客户端失败");
            }
          });
          //}
        } else {
          window.open(
            `http://${window.location.hostname}:${window.location.port}/qualityData/workFlow/${data.bizPk}?qualityId=${data.instProps.qualityId}&useCompany=${data.instProps.useCompany}`
          );
        }
      } else {
        if (data.doUrl === undefined || data.doUrl === null) {
          this.$message.error("无效业务地址!");
          return;
        }
        if (data.doUrl.indexOf("?") !== -1) {
          window.open(
            `http://${window.location.hostname}:${window.location.port}${data.doUrl}&bizPk=${data.bizPk}`
          );
        } else {
          window.open(
            `http://${window.location.hostname}:${window.location.port}${data.doUrl}&bizPk=${data.bizPk}`
          );
        }
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleBatchReview() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning("请先选中数据!");
        return;
      } else if (this.multipleSelection.length > 15) {
        this.$message.warning("批量审批数量不能超过15条!");
        return;
      }

      this.batchReviewComment = "同意";
      this.batchReviewDialogVisible = true;
    },
    async handleBatchReviewSure() {
      if (!this.batchReviewComment) {
        this.$message.warning("批量审批意见为必填!");
        return;
      }

      this.batchReviewCount = 0;
      this.errorBatchReviewData = [];
      this.batchReviewing = true;

      for (var i = 0; i < this.multipleSelection.length; i++) {
        let item = this.multipleSelection[i];
        await this.singleReview(item);
      }
    },
    async singleReview(item) {
      let params1 = this.$qs.stringify({
        bizKey: item.bizType,
        bizPk: item.bizPk
      });
      let result1 = await getFlowToolbar(params1);
      if (result1.success && result1.data) {
        result1.data.forEach(row => {
          if (row.pageEvent === "COMPLETE") {
            item.actionVar = row.actionVar;
          }
        });
      }

      let submitData = {
        bizPk: item.bizPk,
        comment: this.batchReviewComment,
        jsonTaskAssignees: "[]",
        taskKey: "",
        taskId: ""
      };

      let result2 = await queryUserTask(item.bizPk);
      if (result2.length > 0) {
        submitData.taskId = result2[0].id;
        submitData.nowKey = result2[0].key;
      }

      var isCa = "";
      var submitUrl = this.$idmConfig.workFlowUrl;

      if (this.pdfFlag) {
        if (this.caFlag) {
          submitUrl = this.$idmConfig.workFlowCaUrl;
          isCa = "1";
        } else {
          submitUrl = this.$idmConfig.workFlowPdfUrl;
          isCa = "";
        }
      }

      if (isCa == "1") {
        const signResult = await this.postProcess(item, submitData).catch(
          msg => false
        );
        if (!signResult) {
          this.$message({
            message: "PDF签名失败",
            showClose: true,
            type: "error"
          });
          this.errorBatchReviewData.push(item);
          this.batchReviewCount++;
          if (this.batchReviewCount === this.multipleSelection.length) {
            let tempArr = [];
            this.errorBatchReviewData.forEach(row => {
              tempArr.push(`${row.title} ${row.submitTime}`);
            });
            this.$message({
              message: `${tempArr.join(",")}操作失败，其余数据操作成功!`,
              showClose: true,
              type: "error"
            });
            this.batchReviewing = false;
            this.batchReviewDialogVisible = false;
            this.handleCurrentChange(1);
          }
          return;
        }
      }

      let finalResult = await this.$axios.post(
        `${submitUrl}/${item.bizPk}`,
        submitData,
        {
          headers: {
            "flow-token": "COMPLETE"
          }
        }
      );

      if (finalResult.data.success) {
      } else {
        this.errorBatchReviewData.push(item);
      }

      this.batchReviewCount++;
      if (this.batchReviewCount === this.multipleSelection.length) {
        if (this.errorBatchReviewData.length > 0) {
          let tempArr = [];
          this.errorBatchReviewData.forEach(row => {
            tempArr.push(`${row.title} ${row.submitTime}`);
          });
          this.$message({
            message: `${tempArr.join(",")}操作失败，其余数据操作成功!`,
            showClose: true,
            type: "error"
          });
        } else {
          this.$message({
            message: "操作成功",
            showClose: true,
            type: "success"
          });
        }

        this.batchReviewing = false;
        this.batchReviewDialogVisible = false;
        this.handleCurrentChange(1);
      }
    },
    async postProcess(item, data) {
      //先走北京ca，后走流程
      let result = null;
      if (!!item.actionVar) {
        //在线签章
        let signResult = await bjcaGenSign(item.bizPk, item.actionVar);
        if (!!signResult) {
          if (signResult.success) {
            result = JSON.parse(signResult.data).id;
          }
        }
      } else {
        //生成pdf签名
        result = await processSign(item.bizPk, data, this).catch(msg => null);
      }

      if (!result) {
        return false;
      }
      data.fileId = result;
      return true;
    },
    getCaAndPdfFlag() {
      getCategoryList("key", "workflowType")
        .then(res => {
          if (res.succeed && res.data[0]) {
            var workflowType = res.data[0].code;
            if (workflowType === "ca") {
              this.pdfFlag = true;
              this.caFlag = true;
            } else if (workflowType === "pdf") {
              this.pdfFlag = true;
              this.caFlag = false;
            } else {
              this.pdfFlag = false;
              this.caFlag = false;
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    this.isZt = false;
    this.isZt = false
    let prjInfo = JSON.parse(sessionStorage.getItem("projectInfo"));
    if (
      prjInfo.mainSectionCode === undefined ||
      prjInfo.mainSectionCode === null ||
      prjInfo.mainSectionCode === ""
    ) {
      this.mainPartCode = prjInfo.mainPrjCode;
    } else {
      this.mainPartCode = prjInfo.mainSectionCode;
    }

    console.log(prjInfo);

    getChildren(this.mainPartCode)
      .then(res => {
        res.forEach(item => {
          item.children = null;
        });
        this.options = res;
      })
      .catch(error => {
        this.$message.error(error);
      });

    this.getTableData();
    this.getCaAndPdfFlag();
  },
  updated() {
    console.log("更新");
  },
  watch: {
    statusType(newVal) {
      this.handleCurrentChange(1);
    },
    dateValues(newVal) {
      this.handleCurrentChange(1);
    },
    partCode(newVal) {
      this.handleCurrentChange(1);
    },
    bizType() {
      this.handleCurrentChange(1);
    }
  }
};
</script>

<style>
.enptyDiaDiv .el-dialog .el-dialog__headerbtn {
  visibility: hidden;
}
#tdMainDiv {
  height: 100%;
}
#tdContentDiv {
  height: 100%;
  background: white;
  padding: 0px 5px 5px 10px;
  box-sizing: border-box;
}
#tdFilterDiv {
  display: flex;
  height: 45px;
  align-items: center;
  justify-content: flex-start;
}
#tdTableDiv {
  height: 100%;
  box-sizing: border-box;
  margin-top: -45px;
  padding-top: 45px;
  padding-bottom: 32px;
}
#tdPaginationDiv {
  height: 32px;
  background: #ecf5ff;
  text-align: left;
  margin-top: -32px;
}
.tdnFilterTitle {
  width: 60px;
  text-align: right;
  font-size: 13px;
  margin-left: 5px;
  white-space: nowrap;
}
</style>

<style lang="less">
#tdFilterDiv {
  .tree-select {
    min-width: 200px;
    .vue-treeselect__control {
      height: 34px;
      line-height: 34px;
      input {
        // readonly: expression(this.readOnly=true);
      }
      .vue-treeselect__placeholder {
        font-size: 13px;
      }
      .vue-treeselect__single-value {
        font-size: 13px;
      }
    }
    .vue-treeselect__option {
      font-size: 13px;
    }
  }
}

.tdDialogDiv {
  .el-dialog__body {
    padding: 0 20px 10px;
  }

  .el-dialog__footer {
    padding: 0 20px 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Todo.vue